import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import './legal.scss';

export default function TermsOfUsePage() {
  pageTitle('Terms of Use');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title="Terms of Use"
        bgSrc="/images/about_hero_bg.jpeg"
        pageLinkText="Terms of Use"
      />
      <Spacing lg="100" md="60" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-10 offset-lg-1">
            <Div className="cs-legal">
              <p className="cs-legal_meta">Effective Date: August 5, 2026</p>
              <p>
                Welcome to Acsytech (&quot;Acsytech,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;). These Terms of Use (&quot;Terms&quot;) govern your access to and use of the website located at acsytech.com (the &quot;Site&quot;), and any related services, tools, content, or products we offer, including AI automation, web design, and digital marketing services (collectively, the &quot;Services&quot;). By accessing or using the Site or Services, you agree to be bound by these Terms. If you do not agree, please do not use the Site or Services.
              </p>

              <h2>1. Eligibility</h2>
              <p>
                You must be at least 18 years old, or the age of majority in your jurisdiction, to use the Site or Services. By using the Site, you represent and warrant that you meet this requirement and that you have the authority to enter into these Terms on behalf of yourself or the entity you represent.
              </p>

              <h2>2. Description of Services</h2>
              <p>
                Acsytech provides AI-powered automation solutions, web design and development, and digital marketing services to businesses. Specific deliverables, pricing, timelines, and scope for any engagement are governed by a separate written proposal, statement of work, or service agreement between Acsytech and the client (&quot;Service Agreement&quot;). Where a conflict exists between these Terms and a Service Agreement, the Service Agreement controls for that engagement.
              </p>

              <h2>3. Acceptable Use</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Site or Services for any unlawful purpose or in violation of any applicable law or regulation.</li>
                <li>Attempt to gain unauthorized access to any portion of the Site, our systems, or any connected network.</li>
                <li>Interfere with or disrupt the integrity or performance of the Site or Services, including through malware, bots, or scraping tools not authorized by us.</li>
                <li>Reproduce, duplicate, copy, sell, resell, or exploit any part of the Site or Services without our express written permission.</li>
                <li>Upload or transmit content that is infringing, defamatory, obscene, or otherwise harmful.</li>
                <li>Use any automated system to extract data from the Site for competitive or commercial purposes without authorization.</li>
              </ul>

              <h2>4. Intellectual Property</h2>
              <p>
                All content on the Site, including text, graphics, logos, icons, images, software, and the overall design and &quot;look and feel,&quot; is the property of Acsytech or its licensors and is protected by applicable intellectual property laws. Except as expressly permitted, you may not copy, modify, distribute, or create derivative works from any content on the Site without prior written consent.
              </p>
              <p>
                Ownership of custom deliverables created for a client (such as websites, automation workflows, or marketing assets) is governed by the applicable Service Agreement. Unless otherwise stated in writing, Acsytech retains ownership of its underlying tools, frameworks, templates, and proprietary methodologies used to deliver the Services, and grants clients a license to use final deliverables as agreed.
              </p>

              <h2>5. Third-Party Links and Services</h2>
              <p>
                The Site or Services may contain links to third-party websites, platforms, or tools (including AI models, advertising platforms, and analytics providers) that are not owned or controlled by Acsytech. We are not responsible for the content, privacy practices, or terms of any third-party sites or services. Your use of third-party services is at your own risk and subject to their respective terms.
              </p>

              <h2>6. Payment and Fees</h2>
              <p>
                Where Services involve payment, fees, billing terms, and refund policies will be set out in the applicable Service Agreement or invoice. Late payments may result in suspension of Services. All fees are non-refundable except as expressly stated in a Service Agreement or as required by law.
              </p>

              <h2>7. Disclaimers</h2>
              <p>
                THE SITE AND SERVICES ARE PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE,&quot; WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. We do not guarantee that the Site will be uninterrupted, secure, or error-free, or that any AI-generated outputs or automation workflows will be free of errors or achieve any particular business result.
              </p>

              <h2>8. Limitation of Liability</h2>
              <p>
                TO THE FULLEST EXTENT PERMITTED BY LAW, ACSYTECH AND ITS OFFICERS, EMPLOYEES, AND CONTRACTORS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, ARISING OUT OF YOUR USE OF THE SITE OR SERVICES. OUR TOTAL LIABILITY FOR ANY CLAIM ARISING FROM THESE TERMS OR THE SERVICES SHALL NOT EXCEED THE AMOUNT YOU PAID TO ACSYTECH IN THE SIX (6) MONTHS PRECEDING THE CLAIM.
              </p>

              <h2>9. Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless Acsytech, its affiliates, and their respective officers, employees, and agents from any claims, damages, losses, or expenses (including reasonable attorneys&apos; fees) arising out of your use of the Site or Services, your violation of these Terms, or your violation of any rights of a third party.
              </p>

              <h2>10. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your access to the Site or Services at any time, with or without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties. Provisions that by their nature should survive termination (including intellectual property, disclaimers, and limitation of liability) will survive.
              </p>

              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of the State of Massachusetts, United States, without regard to its conflict of law principles. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in Worcester County, Massachusetts.
              </p>

              <h2>12. Changes to These Terms</h2>
              <p>
                We may update these Terms from time to time. Material changes will be indicated by updating the &quot;Effective Date&quot; above. Your continued use of the Site or Services after changes are posted constitutes acceptance of the revised Terms.
              </p>

              <h2>13. Contact Us</h2>
              <p>If you have questions about these Terms, please contact us at:</p>
              <p>
                Acsytech<br />
                Email: support@acsytech.com<br />
                Address: Box 491, 4 E Central St, Worcester, MA 01613
              </p>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="100" md="60" />
    </>
  );
}
